(function () {
  const renderStarRating = (el, maxRating = 5) => {
    const rating = parseFloat(el.dataset.reviewAverage);
    if (isNaN(rating)) return;

    let fg = el.querySelector(".star-fg");
    if (!fg) {
      const star = "★";
      const stars = star.repeat(maxRating);
      el.innerHTML = `
				<span class="star-bg">${stars}</span>
				<span class="star-fg">${stars}</span>
			`;
      fg = el.querySelector(".star-fg");
    }
    fg.style.width = `${(rating / maxRating) * 100}%`;
  };

  function initStarRatings(root) {
    (root || document)
      .querySelectorAll('.star-rating:not([data-rendered="true"])')
      .forEach((el) => renderStarRating(el));
  }

  document.addEventListener("DOMContentLoaded", () =>
    initStarRatings(document)
  );

  const initFromEvent = (event, fallbackSelector) => {
    const root =
      (event.detail && (event.detail.container || event.detail.scope)) ||
      (fallbackSelector ? document.querySelector(fallbackSelector) : null) ||
      event.target ||
      document;
    initStarRatings(root);
  };

  document.addEventListener("quickviewLoaded", (e) => {
    const root = (e.detail && e.detail.container) || document.querySelector("#quickshop") || e.target || document;
    initStarRatings(root);
  });

  document.addEventListener('quickviewLoadedCart', (e) => {
    const root = (e.detail && e.detail.container) || document.querySelector("#quickshop-cart") || e.target || document;
    initStarRatings(root);
  });

  document.addEventListener('customkitQuickviewLoaded', (e) => {
    initFromEvent(e, '#custom-kit-quickshop');
  });

  document.addEventListener('facet:rendered', function () {
    initStarRatings(document.getElementById('ProductGridContainer'));
  });
})();
